export default "__VITE_ASSET__Ju1BWgt0__"